if (!customElements.get('pr-footer')) {
  customElements.define(
    'pr-footer',
    class PrFooter extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.menuDisclosures = Array.from(this.querySelectorAll('.pr-footer__menu-disclosure'));
        this.mobileQuery = window.matchMedia('(max-width: 768px)');
        this.mobileOpenStates = null;
        this.wasMobile = null;

        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.handleDisclosureToggle = this.handleDisclosureToggle.bind(this);

        this.menuDisclosures.forEach((disclosure) => {
          disclosure.addEventListener('toggle', this.handleDisclosureToggle);
        });

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleViewportChange);
        } else {
          this.mobileQuery.addListener(this.handleViewportChange);
        }

        this.handleViewportChange();
      }

      disconnectedCallback() {
        if (!this.isInitialized) return;

        this.menuDisclosures.forEach((disclosure) => {
          disclosure.removeEventListener('toggle', this.handleDisclosureToggle);
        });

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mobileQuery.removeListener(this.handleViewportChange);
        }

        this.isInitialized = false;
      }

      handleDisclosureToggle(event) {
        if (!this.mobileQuery.matches) return;

        const index = this.menuDisclosures.indexOf(event.currentTarget);
        if (index === -1) return;

        if (!this.mobileOpenStates) {
          this.mobileOpenStates = this.menuDisclosures.map((disclosure) => disclosure.open);
        }

        this.mobileOpenStates[index] = event.currentTarget.open;
      }

      handleViewportChange() {
        const isMobile = this.mobileQuery.matches;

        if (isMobile) {
          const targetStates = this.mobileOpenStates || this.menuDisclosures.map((_, index) => index === 0);
          this.menuDisclosures.forEach((disclosure, index) => {
            disclosure.open = Boolean(targetStates[index]);
          });
          this.mobileOpenStates = this.menuDisclosures.map((disclosure) => disclosure.open);
        } else {
          if (this.wasMobile) {
            this.mobileOpenStates = this.menuDisclosures.map((disclosure) => disclosure.open);
          }
          this.menuDisclosures.forEach((disclosure) => {
            disclosure.open = true;
          });
        }

        this.wasMobile = isMobile;
      }
    }
  );
}
